import React, { Component } from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";
import uiMoney from "ui-money";

const FERTILITY = "FERTILITY",
  APPLICANT = "applicant",
  PRACTICE = "practice";
const NI_PRODUCTS = ["INTEREST_FREE_LOAN", "LC_TRUE_NO_INTEREST"];
class LoanAmount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msgData: {
        errors: { amount: {} },
        info: { amount: {} },
      },
    };
  }

  static defaultProps = {
    element: {
      name: "amount",
      prefix: "pf-loan-",
      id: "pf-loan-amount",
      label: "Estimated",
      label2: "Amount",
      placeHolder: "$",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colValidationClassName: "messaging",
    },
    minLoanAmt: 499,
    maxLoanAmt: 50000,
    amountMaxLength: 7,
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 6 },
    },
    clientInfo: { brand: "" },
    clientProds: {
      IL: { offers: true },
      NI: { offers: false },
      PRP: { offers: false },
    },
    userType: APPLICANT,
  };

  componentDidMount() {
    if (this.loanAmountInput) {
      this.loanAmountInput.focus();
    }
  }

  initMsgObj = () => {
    const { element } = this.props,
      msgData = {
        errors: {},
        info: {},
      };

    msgData.errors[element.name] = {};
    msgData.info[element.name] = {};

    return msgData;
  };

  generateMessage = (msgType) => {
    let msg = "";
    const MA_minAmt = this.props.clientProds.customMinAmount;
    const msgData = this.initMsgObj(),
      notation = msgType === "error" ? "errors" : "info",
      {
        minLoanAmt,
        maxLoanAmt,
        element,
        userType,
        clientInfo,
        clientProds,
        fieldMetadata,
        MAStateSelected,
      } = this.props,
      loanAmount = fieldMetadata.value ? parseInt(fieldMetadata.value, 10) : 0,
      { brand } = clientInfo,
      msgs = {
        info: {
          default: "Please enter the amount you need.",
          fertility: {
            applOnly:
              "You can include costs for medication and genetic testing in the Estimated Amount.",
            providerNotNI: "Please enter the amount you need.",
            providerSupportsNI: [
              'Please enter the amount you need. The "Estimated Amount" will not be used as part of the credit decision for the Promotional No-Interest Plans',
            ],
          },
        },
        error: {
          stateMA: `${new uiMoney(MA_minAmt, "USD").format(
            0,
          )} is the minimum Fixed Rate Plan amount in Massachusetts.`,
          default: `Please enter an amount between $${minLoanAmt.toLocaleString(
            "en",
          )} and $${maxLoanAmt.toLocaleString("en")}.`,
        },
      };
    const NI = {
      offers: Object.keys(clientProds).some((prodType) =>
        NI_PRODUCTS.includes(prodType),
      ),
    };
    if (msgType === "info") {
      if (brand && brand === FERTILITY) {
        if (userType === PRACTICE) {
          msg = NI.offers
            ? msgs.info.fertility.providerSupportsNI
            : msgs.info.fertility.providerNotNI;
        } else {
          msg = msgs.info.fertility.applOnly;
        }
      } else {
        msg = msgs.info.default;
      }
    } else if (msgType === "error") {
      if (MAStateSelected && loanAmount < MA_minAmt) {
        msg = msgs.error.stateMA;
      } else if (loanAmount < minLoanAmt || loanAmount > maxLoanAmt) {
        msg = msgs.error.default;
      }
    }

    msgData[notation].amount = {
      type: msgType,
      msg: msg,
      id: element.id,
      slug: element.name,
    };

    return msgData;
  };

  handleValueChange = (valueObj, ev) => {
    // valueObj => {formattedValue: "$x,xxx.xx", value: "xxxx.xx", floatValue: xxxx.xx}
    const { fieldMetadata } = this.props;
    fieldMetadata.value = valueObj.value;
  };

  handleBlur = (ev) => {
    const { onEventCallback, minLoanAmt, maxLoanAmt, fieldMetadata } =
        this.props,
      loanAmount = fieldMetadata.value
        ? parseInt(fieldMetadata.value, 10)
        : null;

    let msgData = this.initMsgObj();

    if (!loanAmount || loanAmount < minLoanAmt || loanAmount > maxLoanAmt) {
      msgData = this.generateMessage("error");
      fieldMetadata.status = "invalid";
      fieldMetadata.isValid = false;
    } else {
      fieldMetadata.status = "";
      fieldMetadata.isValid = true;
    }

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, fieldMetadata);
    }

    this.setState({ msgData });
  };

  handleFocus = (ev) => {
    this.setState({ msgData: this.generateMessage("info") });
  };

  render() {
    const {
        colLayout,
        element,
        fieldMetadata,
        minLoanAmt,
        maxLoanAmt,
        clientInfo,
        amountMaxLength,
      } = this.props,
      { brand } = clientInfo,
      infoMsgAsToolTip = brand && brand === "FERTILITY",
      rowClass = `${element.id} overflow-visible`,
      loanAmount = fieldMetadata.value
        ? parseInt(fieldMetadata.value, 10)
        : null;

    let { msgData } = this.state;
    if (
      fieldMetadata.status === "invalid" &&
      (!loanAmount || loanAmount < minLoanAmt || loanAmount > maxLoanAmt)
    ) {
      msgData = this.generateMessage("error");
    } else if (fieldMetadata.isValid && !fieldMetadata.status) {
      msgData.errors.amount = {};
    }

    return (
      <Row className={rowClass}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label className="label-split" htmlFor={element.id}>
            <span className="text">{element.label}</span>
            <span className="text">{element.label2}</span>
          </label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <NumberFormat
            key={fieldMetadata.value}
            id={element.id}
            name={element.name}
            className={fieldMetadata.status}
            getInputRef={(el) => {
              this.loanAmountInput = el;
            }}
            type="tel"
            decimalScale={0}
            maxLength={amountMaxLength}
            prefix={element.placeHolder}
            isNumericString
            allowNegative={false}
            thousandSeparator
            placeholder={element.placeHolder}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onValueChange={this.handleValueChange}
            defaultValue={fieldMetadata.value}
            autoComplete={fieldMetadata.autocomplete || null}
          />
        </Col>
        <Col className={element.colValidationClassName} width={colLayout[3]}>
          <ValidationMsg
            who="loanAmount"
            filterFields={[element.name]}
            msgs={msgData}
            tooltip={infoMsgAsToolTip}
          />
        </Col>
      </Row>
    );
  }
}

LoanAmount.propTypes = {
  userType: PropTypes.string.isRequired,
  colLayout: PropTypes.object.isRequired,
  minLoanAmt: PropTypes.number,
  maxLoanAmt: PropTypes.number,
  element: PropTypes.object.isRequired,
  clientInfo: PropTypes.object.isRequired,
  clientProds: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
  MAStateSelected: PropTypes.bool.isRequired,
  defaultValue: PropTypes.string,
  MA_minAmt: PropTypes.number,
  amountMaxLength: PropTypes.number,
};

export default LoanAmount;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');